<p>faq-equipment works!</p>
